export type MarketOption = {
  label: string
  state: string
  value: string
}

// Alphabetical by label. Values are `${msas.state}/${msas.handle}` and must
// match the backend msas rows (see migrations 1786431716958 / 1786495358217).
export const MARKET_OPTIONS: readonly MarketOption[] = [
  { label: 'Atlanta', state: 'GA', value: 'GA/atlanta' },
  { label: 'Charlotte', state: 'NC', value: 'NC/charlotte' },
  {
    label: 'Greensboro-Winston-Salem',
    state: 'NC',
    value: 'NC/greensboro-winston-salem',
  },
  { label: 'Raleigh-Durham', state: 'NC', value: 'NC/raleigh-durham' },
]

// Shared stale-market guard: a stored market must be one we currently support
// (stale handles like the pre-ACR-20 'NC/greensboro' no longer route
// anywhere). Used by both usePreferredMarketLocalStorage and
// getPreferredHomesRoute so the two fallback paths can't diverge.
export const isKnownMarket = (value: unknown): value is string =>
  typeof value === 'string' &&
  MARKET_OPTIONS.some((option) => option.value === value)
